/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type FeedStateEnum = typeof FeedStateEnum[keyof typeof FeedStateEnum];


export const FeedStateEnum = {
  post_drying: 'post_drying',
  dry: 'dry',
  nearly_dry: 'nearly_dry',
  medium_moist: 'medium_moist',
  moist: 'moist',
  very_moist: 'very_moist',
} as const;
